export function reminderDeliverAt(day, time, now = new Date()) {
    const target = new Date(now);
    if (day === "tomorrow") {
        target.setDate(target.getDate() + 1);
    }
    else if (day === "weekend") {
        const weekday = target.getDay();
        const daysUntilSaturday = weekday === 6 ? 0 : weekday === 0 ? 6 : 6 - weekday;
        target.setDate(target.getDate() + daysUntilSaturday);
    }
    else {
        target.setDate(target.getDate() + 7);
    }
    const hour = time === "lunch" ? 12 : time === "dinner" ? 18 : time === "evening" ? 20 : 9;
    target.setHours(hour, 0, 0, 0);
    if (target.getTime() <= now.getTime()) {
        target.setDate(target.getDate() + (day === "weekend" ? 7 : 1));
    }
    return target;
}
export function truncateText(value, maxLength) {
    return value.length > maxLength ? value.slice(0, maxLength - 1).trimEnd() : value;
}
//# sourceMappingURL=reminders.js.map